import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/admin.jpg'


const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<form class=\"search-box\"><div class=\"input-group\"><input type=\"text\" class=\"form-control shadow-none rounded-0 border-0\" placeholder=\"Pesquise aqui\"><button class=\"default-btn position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20\" type=\"button\"> Pesquisar <i class=\"flaticon-search-interface-symbol position-relative ms-5 top-1\"></i></button></div></form>", 1)
const _hoisted_7 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_8 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_9 = { class: "dropdown profile-dropdown" }
const _hoisted_10 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rounded",
  width: "44",
  height: "44",
  alt: "admin"
}, null, -1)
const _hoisted_12 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_13 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-body-emphasis fw-semibold fs-13" }, "Investidor", -1)
const _hoisted_15 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_16 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_17 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-2" }, null, -1)
const _hoisted_19 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1)
const _hoisted_21 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)

import { defineComponent, ref, onMounted, reactive } from "vue";
  import { useRouter } from 'vue-router';
  import LightDarkSwtichBtn from "./LightDarkSwtichBtn.vue";
  import stateStore from "../../utils/store";
  import { getUser } from '@/utils/funcoes'; 
  import { logout } from "@/services/usuariosService";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {


  const stateStoreInstance = stateStore;
  const isSticky = ref(false);
  
  const controle = reactive({
    usuario: {}
  });


  onMounted(() => {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      isSticky.value = scrollPos >= 100;
    });
  });

  
 
  onMounted(()=> {
    controle.usuario = getUser() as any;
  })

  var router = useRouter();

const sair = () => {

  logout();
  router.push({ name: 'LoginPage' })
}



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: isSticky.value },
    ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(stateStoreInstance).onChange && _unref(stateStoreInstance).onChange(...args)))
          }, _hoisted_5),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(LightDarkSwtichBtn),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(controle.usuario.nomeUsuario), 1),
                _hoisted_14
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("ul", _hoisted_16, [
                _createElementVNode("li", _hoisted_17, [
                  _hoisted_18,
                  _createTextVNode(" Minha conta "),
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_19, [
                  _hoisted_20,
                  _createTextVNode(" Configurações "),
                  _createVNode(_component_router_link, {
                    to: "/profile-settings",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_21, [
                  _hoisted_22,
                  _createTextVNode(" Suporte "),
                  _createVNode(_component_router_link, {
                    to: "/support-desk-card",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", {
                  class: "text-body-secondary fw-semibold transition position-relative",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (sair()))
                }, [
                  _hoisted_23,
                  _createTextVNode(" Sair ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})